import type { ComponentProps } from 'react';
import { useRef } from 'react';
import { SearchInput } from '../search-input';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { useTiclickTableContext } from './context/ticlick-table-context-hook';

export default function TiclickTableFilterSearchInput({
  ...props
}: ComponentProps<typeof SearchInput>) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { table } = useTiclickTableContext();
  const { setFacetValue } = useTableViewHelpers();

  return (
    <SearchInput
      id='table-filter-input'
      ref={inputRef}
      size='sm'
      placeholder='Search...'
      type='text'
      aria-label='Search'
      onValueChange={(value) => {
        table.setPageIndex(0);

        setTimeout(() => {
          setFacetValue({
            field: props.queryKey || 'name',
            friendlyField: 'Search',
            value: value ? [value] : [],
          });
        }, 0);
      }}
      {...props}
    />
  );
}
